import { Component, ViewChild } from '@angular/core';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { MatStepper } from '@angular/material/stepper';
import { AdditionalsComponent } from '../additionals/additionals.component';
import { PersonComponent } from '../person/person.component';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { VehiclesComponent } from '../vehicles/vehicles.component';

@Component({
    selector: 'app-reservation',
    templateUrl: './reservation.component.html',
    styleUrls: ['./reservation.component.scss'],
})
export class ReservationComponent {
    // Flags para controlar a exibição dos componentes
    showVehicles = true;      // Step 1
    showAdditionals = false;  // Step 2
    showPerson = false;       // Step 3
    showPayment = false;      // Step 4
    pagamentoStripe = 'N'

    constructor(private router: Router) {
        this.pagamentoStripe = sessionStorage.getItem('pagamentoStripe')
    }

    @ViewChild(AdditionalsComponent) additionalsComponent!: AdditionalsComponent;

    @ViewChild(PersonComponent) personComponent!: PersonComponent;

    @ViewChild(VehiclesComponent) vehicleComponent!: VehiclesComponent;

    onStepChange(event: StepperSelectionEvent): void {
        // Limpa todos os shows
        this.showVehicles = false;
        this.showAdditionals = false;
        this.showPerson = false;
        this.showPayment = false;

        // Ativa só o componente do step atual
        switch (event.selectedIndex) {
            case 0:
                this.showVehicles = true;
                break;
            case 1:
                this.showAdditionals = true;
                break;
            case 2:
                this.showPerson = true;
                break;
            case 3:
                this.showPayment = true;
                break;
        }
    }

    async nextFromPerson(stepper: MatStepper): Promise<void> {
        if (this.pagamentoStripe === 'S') {
            const canProceed = await this.personComponent.nextPage();
            if (canProceed) {
                stepper.next();
            }
        } else {
            this.personComponent.submitForm();
        }
    }

    leavePage() {
        this.router.navigateByUrl(AppPages.HOME);
    }

    // Função para avançar do step 2 após salvar o summary
    nextFromAdditionals(stepper: MatStepper): void {
        // Chama o método do componente filhos que atualiza o summary
        this.additionalsComponent.submitForm();

        // Avança o stepper
        stepper.next();
    }
}